export default __webpack_public_path__ + "static/media/Kuiil.3702e9a9.webp";